import { render, staticRenderFns } from "./ViewFooter.vue?vue&type=template&id=0c400c62&scoped=true&"
import script from "./ViewFooter.vue?vue&type=script&lang=js&"
export * from "./ViewFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c400c62",
  null
  
)

export default component.exports